<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <ElSelect
            v-model="fieldValue"
            class="search-preference__select"
            size="small"
            :placeholder="$t(fieldConfig.label)"
            @change="syncChange"
        >
            <ElOption
                v-for="option in targetSeqLimitOptionsFinal"
                :key="option.value"
                :value="option.value"
                :disabled="option.disabled"
            >
                <ElTooltip
                    v-if="option.tooltip"
                    placement="right-start"
                    effect="light"
                    :visible-arrow="false"
                    :content="option.tooltip"
                >
                    <span>{{ option.label }}</span>
                </ElTooltip>
                <span v-else>
                    {{ option.label }}
                </span>
            </ElOption>
        </ElSelect>
    </FieldItem>
</template>

<script>
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import Tooltip from 'element-ui/lib/tooltip';
import map from 'lodash/map';
import assign from 'lodash/assign';
import FieldItem from '../components/FieldItem.vue';
import { FieldItemMixin } from './mixins';
import { targetSeqLimitOptions } from '../constants/constantConfig';

export default {
    components: {
        FieldItem,
        ElSelect: Select,
        ElOption: Option,
        ElTooltip: Tooltip,
    },
    mixins: [FieldItemMixin],
    inject: {
        store: {
            from: 'store',
        },
        state: {
            from: 'state',
            default: null,
        },
    },
    props: {
        fieldName: {
            type: String,
            default: 'limit',
        },
        amountLimit: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        proxyAmountLimit() {
            if (this.state && 'amountLimit' in this.state) {
                return this.state.amountLimit;
            }
            return this.amountLimit;
        },
        targetSeqLimitOptionsFinal() {
            return map(targetSeqLimitOptions, (opt) => assign(
                { ...opt },
                opt.value === 50000 && this.proxyAmountLimit
                    ? {
                        disabled: true,
                        tooltip: this.$tc(
                            'Search.labels.targetSeqLimitTooltip',
                        ),
                    } : {},
            ));
        },
    },
};
</script>
